import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // baseURL: `https://op8vg1apd5.execute-api.ap-southeast-1.amazonaws.com/develop`,
  // baseURL: `https://op8vg1apd5.execute-api.ap-southeast-1.amazonaws.com/prod`,
  withCredentials: false, // This is the default
  timeout: 30000,
})
//const token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJidUlkIjoiYTA1MjhmNjAtNGQzMC00NzM1LTkxNTgtYjUyNjFkZGQ1YmY0IiwiaWF0IjoxNzAzMzUyMzY1LCJleHAiOjIyMjI5OTk5OTl9.olQUWY4sl4yv9EMt8bKmAlXnnKeEjlB1htZax7HayBE"
const token = process.env.VUE_APP_TOKEN_X
export default {
  getBillBank(linkcode) {
    return apiClient.get(
      '/WPG-Bill-Bank?linkcode=' + linkcode,
      //,{ headers: { "token" :  token} }
      { headers: { Authorization: 'Bearer ' + token } }
    )
  },
  getBillData(linkcode) {
    return apiClient.get(
      '/WPG-Bill-Data-v1?linkcode=' + linkcode,
      //,{ headers: { "token" :  token} }
      { headers: { Authorization: 'Bearer ' + token } }
    )
    //return apiClient.get('/WPG-Bill-Data?linkcode=' + linkcode)
  },
  getBillDataValidated(linkcode) {
    // console.log("Call Get WPG-Bill-Data-Validated  >>>",linkcode)
    return apiClient.get(
      '/WPG-Bill-Data-Validated?linkcode=' + linkcode,
      { headers: { Authorization: 'Bearer ' + token } }
      //,{ headers: { "token" :  token} }
    )
  },
  getBillPayment(linkcode) {
    return apiClient.get(
      '/WPG-BILL-PAYMENT?linkcode=' + linkcode,
      //,{ headers: { "token" :  token} }
      { headers: { Authorization: 'Bearer ' + process.env.TOKEN } }
    )
  },
  getMaster(body) {
    return apiClient.post('/WPG-Get-Master', body, {
      headers: { token: token },
    })
  },
  getQrCredit(bubankid, linkcode, amount) {
    return apiClient.get(
      '/WPG-Payment-QR-Credit?bubankid=' +
        bubankid +
        '&linkcode=' +
        linkcode +
        '&amount=' +
        amount
    )
  },
  getSCBEasy(bubankid, linkcode, amount) {
    // const apiClient = axios.create({
    //   baseURL: `http://10.5.50.39:3000/api`,
    //   // baseURL: `https://op8vg1apd5.execute-api.ap-southeast-1.amazonaws.com/prod`,
    //   withCredentials: false, // This is the default
    //   timeout: 30000
    // })

    return apiClient.get(
      '/WPG-Payment-SCB-Easy?bubankid=' +
        bubankid +
        '&linkcode=' +
        linkcode +
        '&amount=' +
        amount
    )
  },
  //Fix QR Onward 11/10/24
  getPPCSQr(bubankid, linkcode) {
    return apiClient.get(
      '/WPG-Payment-QR-PPCS?bubankid=' + bubankid + '&linkcode=' + linkcode
    )
  },

  async getPaymentQr(bubankid, trantype, refcode, amount) {
    console.log('Trans Type:', trantype)
    if (trantype == 'A' || trantype == 'W' || trantype == 'X') {
      let response = await apiClient.get(
        '/WPG-Payment-Alipay-QR?bubankid=' +
          bubankid +
          '&trantype=' +
          trantype +
          '&refcode=' +
          refcode +
          '&amount=' +
          amount
      )
      console.log(response.data)
      if (trantype == 'W' || trantype == 'X') {
        let qrdata = response.data.split('text=', 2)
        return apiClient.get('/WPG-QRGenerate?text=' + qrdata[1])
      } else {
        return response
      }
    }
    // return apiClient.get(
    //   '/WPG-Payment-Alipay-QR?bubankid=' +
    //     bubankid +
    //     '&trantype=' +
    //     trantype +
    //     '&refcode=' +
    //     refcode +
    //     '&amount=' +
    //     amount
    // )
    else
      return apiClient.get(
        '/WPG-Payment-Thai-QR?bubankid=' +
          bubankid +
          '&refcode=' +
          refcode +
          '&amount=' +
          amount
      )
  },
  recieveDepositBillUrl(body) {
    return apiClient.post('/WPG-Create-Bill-Data', body)
  },
  submitCreditCard(body) {
    return apiClient.post('/WPG-Payment-Credit', body)
  },
  getTwocTwopIntegrate(body) {
    let frontcallback = `${window.location.protocol}//${window.location.host}/paymentSuccess/?linkcode=${body.linkcode}`
    body.frontendReturnUrl =
      process.env.VUE_APP_API_BASE_URL +
      '/WPG-2C2P-Integrate-V1/?frontcallback=' +
      frontcallback
    body.backendReturnUrl =
      process.env.VUE_APP_API_BASE_URL +
      '/WPG-2C2P-Backend-V1/?buid=' +
      body.userDefined3
    // console.log(JSON.stringify(body))
    return apiClient.post('/WPG-2C2P-Integrate-V1', body)
  },
  getDeeplinkIntegrate(body) {
    let frontcallback = `${window.location.protocol}//${window.location.host}/paymentSuccess/?deeplink=1&linkcode=${body.userDefined1}`
    let paymentMethods_url = `${window.location.protocol}//${window.location.host}/paymentMethods/?linkcode=${body.userDefined1}`
    let paymentFail_url = `${window.location.protocol}//${window.location.host}/paymentFail/?linkcode=${body.userDefined1}`
    body.confirmationURL = frontcallback
    body.failedURL = paymentFail_url
    body.cancellationURL = paymentMethods_url
    body.backendURL =
      process.env.VUE_APP_API_BASE_URL +
      '/WPG-DeepLink-Backend-V1/?buid=' +
      body.userDefined3 +
      '&linkcode=' +
      body.userDefined1 +
      '&ref1=' +
      body.userDefined2
    // console.log(JSON.stringify(body))
    return apiClient.post('/WPG-DeepLink-Integrate-V1', body)
  },
}
